import React from 'react';
import { AllieCheckbox } from '../../../Checkbox';
import { DataGridCellBaseProps } from '../../DataGridCell.types';

export type DataGridCheckCellProps = { size?: number };

export const DataGridCheckboxCell: React.FC<DataGridCellBaseProps> = ({
  row,
  cellProps,
}) => {
  const size = cellProps?.size ?? 24;
  return (
    <AllieCheckbox
      {...{
        checked: row.getIsSelected(),
        disabled: !row.getCanSelect(),
        indeterminate: row.getIsSomeSelected(),
        onClick: row.getToggleSelectedHandler(),
        size,
      }}
    />
  );
};
